import {
  FOCUS_TEMPLATES,
  FOCUS_TEMPLATE_KEY_SET,
  SERIES_FOCUS_TEMPLATES,
  SERIES_FOCUS_TEMPLATE_KEY_SET,
  focusColumnLabel,
} from './focusTemplates';
import { sessionMessageSummary } from './writerCopy';
import { isPaneRoomSession } from './roomChat';

export const MOCK_STAND_IN_KINDS = ['conflict', 'theme', 'plot-theme', 'plot_theme'];

export function isDiscoverySession(session, discoveryId) {
  if (!session) return false;
  if (session.session_type === 'discovery') return true;
  return Boolean(discoveryId) && session.id === discoveryId;
}

export function partitionSessions(sessions, discoveryId) {
  const list = Array.isArray(sessions) ? sessions : [];
  let discovery = null;
  const explore = [];
  const focus = [];

  list.forEach((session) => {
    if (isPaneRoomSession(session)) return;
    if (isDiscoverySession(session, discoveryId)) {
      if (!discovery) discovery = session;
      return;
    }
    if ((session.guidance_mode || 'explore') === 'explore') {
      explore.push(session);
      return;
    }
    if ((session.guidance_mode || '') === 'focus') {
      focus.push(session);
    }
  });

  return { discovery, explore, focus };
}

/**
 * Columns for the Focus board: live picker kinds first (always), then
 * any other existing focus template that still has sittings. Retired
 * workshop kinds do not get an empty column. Mock stand-in names are
 * never invented.
 */
export function focusColumnsForSessions(focusSessions, { seriesAltitude = false } = {}) {
  const picker = seriesAltitude ? SERIES_FOCUS_TEMPLATES : FOCUS_TEMPLATES;
  const pickerKeys = seriesAltitude ? SERIES_FOCUS_TEMPLATE_KEY_SET : FOCUS_TEMPLATE_KEY_SET;
  const byTemplate = new Map();
  (focusSessions || []).forEach((session) => {
    const key = session.template || 'open';
    if (!byTemplate.has(key)) byTemplate.set(key, []);
    byTemplate.get(key).push(session);
  });

  const columns = picker.map((kind) => ({
    key: kind.key,
    label: kind.label,
    sessions: byTemplate.get(kind.key) || [],
    fromPicker: true,
  }));

  Array.from(byTemplate.keys())
    .filter((key) => !pickerKeys.has(key))
    .filter((key) => !MOCK_STAND_IN_KINDS.includes(String(key).toLowerCase()) || (byTemplate.get(key) || []).length > 0)
    .sort()
    .forEach((key) => {
      const sessions = byTemplate.get(key) || [];
      if (sessions.length === 0) return;
      if (seriesAltitude && (key === 'scene' || key === 'dialogue')) return;
      columns.push({
        key,
        label: focusColumnLabel(key, seriesAltitude),
        sessions,
        fromPicker: false,
      });
    });

  return columns;
}

export function sessionCardSummary(session) {
  const description = (session?.description || '').trim();
  if (description) return description;
  const count = session?.message_count || 0;
  if (count > 0) return sessionMessageSummary(count);
  return 'Open to continue.';
}

export function sessionSittingStamp(iso, now = new Date()) {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfThat = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const days = Math.round((startOfToday - startOfThat) / 86400000);
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days > 1 && days < 7) {
    return date.toLocaleDateString(undefined, { weekday: 'short' });
  }
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
